<template>
  <div class="form-lower entry">
    <lang />
    <section class="wrapper">
      <div class="form_ttl">
        <h1>
          <router-link :to="{ name: 'Home', params: { lang: $route.params.lang }}">
            <img src="@/assets/img/client/logo.png" alt="GLOCALY">
          </router-link>
        </h1>
      </div>
      <div class="entry_contents">
        <div>
          <p class="intro" v-html="$t('entry_detail_header1')"></p>
          <div class="form_wrapper">
            <h2>{{ $t('New member registration') }}</h2>
              <label>{{ $t('email_address') }} <span class="ilB" v-show="currentlanguage !== 'zh-tw' && currentlanguage !== 'zh-cn'">{{ $t('member_id') }}</span>
              <input type="text" v-model="$v.email_address.$model" placeholder="glocaly@example.com" :state="validateState()"></label>
              <b-form-invalid-feedback :state="validateState()">
                <p v-if="!$v.email_address.required">{{ $t('Email address is required') }}</p>
                <p v-if="!$v.email_address.email">{{ $t('Invalid e-mail address format') }}</p>
              </b-form-invalid-feedback>
              <b-form-invalid-feedback :state="!emailExist">
                <p>{{ $t('Email exist') }}</p>
              </b-form-invalid-feedback>
              <a :href="'https://www.lead-real.co.jp/' + currentlanguageRoute + 'privacy/'"  target="_blank">{{ $t('protection_policy') }}</a>
              <button type="button" @click="preRegister" tag="button" class="brown_btn" v-html="$t('confirmation_screen')"></button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import lang from '@/components/client/language/language'
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      currentlanguage: this.$route.params.lang,
      email_address: null,
      languageFormat: this.$route.params.lang,
      grecaptcha: null
    }
  },
  validations: {
    email_address: { required, email }
  },
  components: {
    lang
  },
  created () {
    this.$store.commit('login/setEmailExist', null)
    /* eslint-disable */
    // 本来であれば vue-recaptcha-v3 のようなライブラリを使うが、node.js のバージョンの関係でインストールできなかったので、APIを直接叩くようにしている
    const scriptEle = document.createElement('script')
    scriptEle.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + process.env.VUE_APP_RECAPTCHA_SITE_KEY)
    scriptEle.setAttribute('async', true)
    scriptEle.addEventListener('load', () => {
      this.grecaptcha = grecaptcha
    })
    document.body.appendChild(scriptEle)
    /* eslint-enable */
  },
  computed: {
    ...mapState('login', ['emailExist']),
    currentlanguageRoute () {
      if (this.currentlanguage === 'zh-cn') {
        return 'zh/'
      } else if (this.currentlanguage === 'ja') {
        return ''
      }
      return this.currentlanguage + '/'
    }
  },
  methods: {
    ...mapActions('login', ['preRegisteredClient']),
    validateState () {
      const { $dirty, $error } = this.$v.email_address
      return $dirty ? !$error : null
    },
    preRegister () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.grecaptcha.ready(() => {
          this.grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, { action: 'submit' }).then((token) => {
            const data = {
              post: {
                email_address: this.email_address,
                token: token
              },
              language: this.$route.params.lang
            }
            this.preRegisteredClient(data)
            this.$store.commit('login/setEmailExist', null)
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" src="@/assets/sass/client/index.scss">

</style>
